module.exports = __webpack_public_path__ + "img/30f52d6afb998b2136bda6967d27caf9.2a8788ba.png";